<template>
<h1><font-awesome-icon icon="temperature-half" /></h1>
<u>Lufttemperatur</u>
<br>
<DialGauge :value="value" :min="-20" :max="40" :zones="ZONES" unit="°C" id-prefix="temp" />
<b>{{ value === null ? '--' : value }} °C</b>
</template>

<script>
import DialGauge from './DialGauge.vue'

// colored scale zones: [from, to, color]
const ZONES = [
  [-20, 0, '#3b82f6'],
  [0, 15, '#06b6d4'],
  [15, 25, '#22c55e'],
  [25, 30, '#f59e0b'],
  [30, 40, '#ef4444']
]

export default {
  name: 'AirTemperature',
  components: { DialGauge },
  props: {
    temp: Number
  },
  data() {
    return { ZONES }
  },
  computed: {
    value() {
      return Number.isFinite(this.temp) ? this.temp : null
    }
  }
}
</script>
